import React, { useState } from "react";
import ReactModal from "react-modal";
import Iframe from "react-iframe";
import { AiOutlineClose, AiOutlineEye } from "react-icons/ai";

// 🔥 importante para accesibilidad
ReactModal.setAppElement("#root");

function ConsultarReporte({ url }) {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const customStyles = {
    overlay: {
      backgroundColor: "rgba(0,0,0,0.6)",
      zIndex: 2000,
    },
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      transform: "translate(-50%, -50%)",
      width: "95%",
      height: "90vh",
      borderRadius: "12px",
      padding: "0",
      border: "none",
      overflow: "hidden",
    },
  };

  return (
    <>
      {/* 🔥 BOTÓN MODERNO */}
      <button
        className="btn btn-outline-primary btn-sm d-flex align-items-center gap-1"
        onClick={openModal}
      >
        <AiOutlineEye />
        Ver
      </button>

      {/* 🔥 MODAL */}
      <ReactModal
        isOpen={isOpen}
        onRequestClose={closeModal}
        style={customStyles}
      >
        {/* HEADER */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "10px 15px",
            borderBottom: "1px solid #eee",
            background: "#f9fafb",
          }}
        >
          <span style={{ fontWeight: "600" }}>Vista del Reporte</span>

          <button
            onClick={closeModal}
            style={{
              border: "none",
              background: "transparent",
              fontSize: "20px",
              cursor: "pointer",
            }}
          >
            <AiOutlineClose />
          </button>
        </div>

        {/* CONTENIDO */}
        <div style={{ width: "100%", height: "100%" }}>
          <Iframe
            url={url}
            width="100%"
            height="100%"
            display="block"
            position="relative"
            styles={{ border: "none" }}
          />
        </div>
      </ReactModal>
    </>
  );
}

export default ConsultarReporte;
